import { Card } from "antd";

type DashboardCardTypes = {
  data: {
    name: string;
    icon: any;
    number: number | string;
    prefix: string;
  };
};

const DashboardCard = ({ data }: DashboardCardTypes) => {
  return (
    <Card className="stat_card">
      <div
        style={{
          alignItems: "center",
          margin: "auto",
        }}
      >
        <div className="card_icon">
          <img className="symbols" src={data.icon}></img>

          <div>
            <div className="card_heading1">{data.name}</div>
            <div className="card_heading2">{`${data.prefix} ${data.number}`}</div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default DashboardCard;
